<script>

const DOMParser = window.DOMParser
const parser = new DOMParser()

export default {
  props: {
    src: {
      type: String,
      required: true
    }
  },
  render (h) {
    const file = require(`!svg-inline-loader!@/assets/svg/${this.src}.svg`)
    const document = parser.parseFromString(file, 'text/xml')
    const svg = document.getElementsByTagName('svg')[0]

    const attrs = {}

    Array.prototype.forEach.call(svg.attributes, (attribute) => {
      attrs[attribute.nodeName] = attribute.nodeValue
    })

    return h('svg', {
      ...this.data,
      attrs,
      domProps: {
        innerHTML: svg.innerHTML
      }
    })
  }
}
</script>
